import React from "react";
import "./C1Page.css";

const C1CourseDetails = () => {
  return (
    <div className="c1DetailsContainer">
      <ul>
        <li>
          It is the advanced level and a higher Proficiency Language level. The
          course is sub divided into C1.1 and C1.2.
        </li>
        <li>It helps to prepare to study at a University in Germany.</li>
      </ul>
      <h3>What to expect after completion of course?</h3>
      <ul>
        <li>
          Can understand a wide range of demanding, longer texts and also
          recognize implicit meaning.
        </li>
        <li>
          Can express ideas spontaneously and fluently without any searching of
          words.
        </li>
        <li>
          Can easily speak in social, professional and economic scenarios.
        </li>
        <li>
          Can summarize information from a variety of spoken and written
          sources.
        </li>
        <li>Can create detailed presentations and reports.</li>
      </ul>
    </div>
  );
};

export default C1CourseDetails;
